import { BasicUserWithName, PosState, userStoreType } from '../auth/authTypes';

export enum InvoiceStatus {
  PENDING = 'PENDING',
  PAID = 'PAID',
  CANCELLED = 'CANCELLED',
  OPEN = 'OPEN',
  SENT_TO_KITCHEN = 'SENT_TO_KITCHEN',
  PREPARING = 'PREPARING',
  READY = 'READY',
  SERVED = 'SERVED',
  OUT_FOR_DELIVERY = 'OUT_FOR_DELIVERY',
  DELIVERED = 'DELIVERED',
}

export type Pending_Type =
  | 'START_SHIFT'
  | 'TICKET_SUBMIT'
  | 'INVOICE_SEND'
  | 'INVOICE_SEND_TO_KITCHEN'
  | 'ADD_CASH'
  | 'CLOSE_SHIFT';

export interface ModifierOptionType {
  ID: string;
  name: string;
  nameAr?: string;
  price: number;
}

export interface DataType {
  categories: CategoryType[];
  items: ItemType[];
  modifiers: ModifierType[];
  discounts: DiscountType[];
  shift?: ShiftType | null;
  tickets?: TicketType[] | [];
  pendings?: PendingsType[] | [];
  invoices?: InovicesType[] | [];
  cashes?: CashType[] | [];
}

export interface BasicCustomerWithName {
  _id: string;
  name: string;
}

export interface CashType {
  ID: string;
  value: number;
  comment?: string;
  shiftId: string;
  type: 'IN' | 'OUT';
  createdAt: Date | string;
}
export interface TicketType {
  ID: string;
  name?: string;
  comment?: string;
  items?: TicketItemType[];
  discounts?: TicketDiscountType[];
  modifierOptions?: TicketModifierOptionsType[];
  status: 'ACTIVE' | 'BACKLOG';
  payType?: 'CARD' | 'CASH' | 'BOTH' | 'CREDIT';
  type: 'PAY' | 'REFUND';
  category?: 'IN' | 'OUT' | 'DELIVERY';
  createdAt: Date | string;
  customerId?: string;
  invoiceStatus?: InvoiceStatus;
  tableId?: string | null;

  // indicate if the ticket has been saved to the backend
  // used when opening an opened invoice so that we do not add it again to the backend
  savedToBackend?: boolean;
}

export interface InovicesType {
  ID: string;
  name?: string;
  shiftId: string;
  items?: TicketItemType[];
  modifierOptions?: TicketModifierOptionsType[];
  discounts?: TicketDiscountType[];
  pos: PosState | null;
  store: userStoreType | null;
  creator: BasicUserWithName | null;
  customer?: BasicCustomerWithName;
  payouts?: any;
  category?: 'IN' | 'OUT' | 'DELIVERY';
  payType?: 'CARD' | 'CASH' | 'BOTH' | 'CREDIT';
  type?: 'PAY' | 'REFUND';
  total: number;
  number: number;
  createdAt: Date | string;
  currency?: string;
  updatedAt?: Date | string;
  originalInvoiceId?: string;
  status?: InvoiceStatus;
}

export interface TicketItemType {
  ID: string;
  quantity: number;
  numberOfRefunds?: number;
  name: string;
  nameAr?: string;
  sellingType: 'QUANTITY' | 'WEIGHT';
  price: number;
  SKU: string;
  cost?: number;
  categoryId?: string;
  notes?: string;
}
export interface TicketDiscountType {
  ID: string;
  name: string;
  type: 'PERCENT' | 'VALUE';
  value: number;
}
export interface TicketModifierOptionsType {
  ID: string;
  name: string;
  quantity: number;
  numberOfRefunds?: number;
  nameAr?: string;
  price: number;
}
export interface PendingsType {
  type?: Pending_Type;
  ID?: string;
  data?: any;
}
export interface ShiftType {
  ID: string;
  startDate: Date | string;
  startAmount: number;
  endDate?: Date | string;
  endAmount?: number;
}

export interface CategoryType {
  ID: string;
  createdAt: string;
  name: string;
  color: string;
}
export interface ItemType {
  ID: string;
  name: string;
  nameAr: string;
  sellingType: 'QUANTITY' | 'WEIGHT';
  price?: number;
  priceAfterTax?: number;
  cost?: number;
  SKU: string;
  trackStock: boolean;
  quantity?: number;
  stock?: number;
  iconType: 'COLOR' | 'IMAGE';
  iconValue: string;
  enabled?: boolean;
  barcode?: string;
  categoryId?: string;
  category: CategoryType;
  description?: string;
  descriptionAr?: string;
}

export interface ModifierType {
  name: string;
  nameAr?: string;
  options: ModifierOptionType[];
}
export interface DiscountType {
  ID: string;
  name: string;
  nameAr?: string;
  type: 'PERCENT' | 'VALUE';
  value?: number;
}
